export default "__VITE_ASSET__DDRlQRzC__"